import { type PositionedImage } from '@/utils/type.util'

export const CASE_MATERIAL_IMAGE_SIZE = 2000

export function calculateMaxRowNumber(
  containerWidth: number,
  clientWidth: number,
  spacing: number,
): number {
  if (clientWidth <= 0) return 0
  return Math.max(0, Math.floor((containerWidth + spacing) / (clientWidth + spacing)))
}

export function toFullSizeImage(url: string): PositionedImage {
  return {
    url,
    rect: { x: 0, y: 0, width: CASE_MATERIAL_IMAGE_SIZE, height: CASE_MATERIAL_IMAGE_SIZE },
  }
}
